module.exports = __webpack_public_path__ + "static/media/hands-vertical-bw-full.c95590f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hands-vertical-bw-full.jpg
// module id = 27
// module chunks = 0